/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkopensignup3Inputs */

const en_ticketlinkopensignup3 = /** @type {(inputs: Ticketlinkopensignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const de_ticketlinkopensignup3 = /** @type {(inputs: Ticketlinkopensignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Anmeldung`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Ticketlinkopensignup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkopensignup3 = /** @type {((inputs?: Ticketlinkopensignup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkopensignup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkopensignup3(inputs)
	return de_ticketlinkopensignup3(inputs)
});
export { ticketlinkopensignup3 as "ticketLinkOpenSignup" }